

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETDESIGNATIONBYID= createAsyncThunk(
  "getDesignationById/getDesignationById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getDesignationByIdSlice = createSlice({
  name: "getDesignationByIdSlice",
  initialState: {
    getDesignationById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetDesignationById: (state) => {
        state.getDesignationById.loading = false
        state.getDesignationById.error = false
        state.getDesignationById.data = []
        state.getDesignationById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETDESIGNATIONBYID.fulfilled, (state, action) => {
      state.getDesignationById = {
        ...state.getDesignationById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETDESIGNATIONBYID.pending, (state, action) => {
      state.getDesignationById = {
        ...state.getDesignationById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETDESIGNATIONBYID.rejected, (state, action) => {
      state.getDesignationById = {
        ...state.getDesignationById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getDesignationByIdAction = {
    GETDESIGNATIONBYID,
};

export { getDesignationByIdAction };
export default getDesignationByIdSlice.reducer;
export const {setInitialStateOfgetDesignationById} = getDesignationByIdSlice.actions
